import script from "./BasicInformation.vue?vue&type=script&lang=ts&setup=true"
export * from "./BasicInformation.vue?vue&type=script&lang=ts&setup=true"

import "./BasicInformation.vue?vue&type=style&index=0&id=444156e7&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-444156e7"]])

export default __exports__